<template>
  <router-link :class="realisation.class" :to="realisation.href">
    <div class="box">
      <div class="box--overlay"></div>
      <img :src="realisation.thumbnail"/>
      <h3>{{ realisation.titles.fr.join(' / ') }}<br/><span>{{ realisation.titles.en.join(' / ') }}</span></h3>
    </div>
  </router-link>
</template>

<script>
  export default {
    name: "RealisationBox",
    props: {
      realisation: {
        required: true,
        type: Object
      }
    }
  }
</script>

<style lang="scss" scoped>
img {
  object-fit: cover;
}

</style>